import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CommonModule } from "@angular/common";

import { DashboardComponent } from './module/dashboard/dashboard/dashboard.component';
import { LoginComponent } from './module/login/login/login.component';
import { AddinstoreComponent } from './module/addinstore/addinstore/addinstore.component';
import { AddcampaignComponent } from './module/addcampaign/addcampaign/addcampaign.component';
import { AddhoardingComponent } from './module/addhoarding/addhoarding/addhoarding.component';
import { BulkuploadComponent } from './module/bulkupload/bulkupload/bulkupload.component';
import { UsermanagementComponent } from './module/usermanagement/usermanagement/usermanagement.component';

import { InstorelistComponent } from './module/instorelist/instorelist/instorelist.component';
import { CampaignlistComponent } from './module/campaignlist/campaignlist/campaignlist.component';  
import { ReportComponent } from './module/report/report/report.component';  
import { CalenderComponent } from './module/calender/calender/calender.component';
import { HoardinglistComponent } from './module/hoardinglist/hoardinglist/hoardinglist.component';

import { MapComponent } from './module/map/map/map.component';
import { BulkcampaignComponent } from './module/bulkcampaign/bulkcampaign/bulkcampaign.component';
import { BulkhoardingComponent } from './module/bulkhoarding/bulkhoarding/bulkhoarding.component';
import { ProfileComponent } from './module/profile/profile/profile.component';
import { PasswordComponent} from './module/password/password/password.component'
import { AuthGuard } from './_guards/index';

const routes: Routes = [ 
  {
    path:'login',
    component: LoginComponent
  },
  {
    path:'dashboard',
    component: DashboardComponent, canActivate: [AuthGuard]
  },
  {
    path: 'addinstore',
    component: AddinstoreComponent, canActivate: [AuthGuard]
  },
  {
    path: 'addcampaign',
    component: AddcampaignComponent, canActivate: [AuthGuard]
  },
  {
    path: 'addhoarding',
    component: AddhoardingComponent, canActivate: [AuthGuard]
  },
  {
    path: 'bulkupload',
    component: BulkuploadComponent, canActivate: [AuthGuard]
  },
  {
    path: 'instorelist',
    component: InstorelistComponent, canActivate: [AuthGuard]
  },
  {
    path: 'campaignlist',
    component: CampaignlistComponent , canActivate: [AuthGuard]
  },

  {
    path:'report',
    component: ReportComponent, canActivate: [AuthGuard]
  },
  {
    path:'calender',
    component: CalenderComponent, canActivate: [AuthGuard]
  },
  {
    path:'hoardinglist',
    component: HoardinglistComponent, canActivate: [AuthGuard]
  },
  {
    path:'map',
    component: MapComponent, canActivate: [AuthGuard]
  },
  {
    path:'bulkcampaign',
    component: BulkcampaignComponent, canActivate: [AuthGuard]
  },
  {
    path:'bulkhoarding',
    component: BulkhoardingComponent, canActivate: [AuthGuard]
  },
  {
    path:'profile',
    component: ProfileComponent, canActivate: [AuthGuard]
  },
  {
    path:'password',
    component: PasswordComponent, canActivate: [AuthGuard]
  },
  {
    path:'',
    redirectTo:'/dashboard',
    pathMatch:'full'
  }, {
    path:'usermanagement',
    component: UsermanagementComponent, canActivate: [AuthGuard]
  }
];

@NgModule({
  // imports: [RouterModule.forRoot(routes), CommonModule],
  imports: [RouterModule.forRoot(routes, { useHash: true }), CommonModule],
  exports: [RouterModule]
})
export class AppRoutingModule { }
